<div
    avi-tooltip
    [hideOnMouseLeave]="false"
    [positionsPriority]="signpostPositionPriorities"
    (onPositionChange)="handleSignpostConnectedPosition($event)"
    [tooltipControl$]="signpostCloseControl$"
    (mouseleave)="handleAlertBellMouseLeave($event)"
    class="avi-alert-bell"
>
    <div 
        class="avi-alert-bell__grid"
        *ngIf="alerts"
    >
        <div *ngFor="let alertKey of alertList">
            <div class="avi-alert-bell__label-grid">
                <div 
                    class="avi-alert-bell__outer"
                    [ngClass]="alertClass(alertKey)"
                ></div>
                
                <label class="avi-alert-bell__label-grid-label">{{ alerts[alertKey] }}</label>
            </div>
        </div>
    </div>

    <ng-template #aviTooltipContent>
        <signpost
            *ngIf="totalAlerts > 0"
            class="avi-alert-bell__signpost"
            [signpostPosition]="signpostPosition"
            (onCloseButtonClick)="closeSignpost()"
            (mouseleave)="closeSignpost()"
        >
            <div class="avi-alert-bell__signpost--wrapper">
                <h3 class="avi-alert-bell__signpost--title">
                    {{ l10nKeys.alertLabel | vtranslate }} ({{ totalAlerts }})
                </h3>

                <div class="avi-alert-bell__signpost--body">
                    <ng-container>
                        <avi-alert-bell-body
                            [objectName]="objectName"
                            [uuid]="uuid"
                            [alertLevelList]="alerts"
                            (onAlertUpdate)="onAlertUpdate($event)"
                        ></avi-alert-bell-body>

                        <avi-alert-bell-footer 
                            *ngIf="!hideViewAlertButton"
                            (onViewAllAlertsClick)="handleViewAllAlertsButtonClick()">
                        </avi-alert-bell-footer>
                    </ng-container>
                </div>
            </div>
        </signpost>
    </ng-template>
</div>
